import { render, staticRenderFns } from "./text-with-value.vue?vue&type=template&id=15f84984&"
import script from "./text-with-value.vue?vue&type=script&lang=js&"
export * from "./text-with-value.vue?vue&type=script&lang=js&"
import style0 from "./text-with-value.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports